import React, { Fragment, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Enregistrement from "./Enregistrement";
import Journalbox from "./Journalbox";
import ReactPaginate from "react-paginate";
import DatePicker from "react-date-picker";
import ScaleLoader from "react-spinners/ScaleLoader";
import { withTranslation } from "react-i18next";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";
import { Listbox } from "@headlessui/react";

////////////////////////////////////////////////////////////////////////::date picker//////////////////////////////
import DatePicker2, { registerLocale } from "react-datepicker";
import DatePicker3 from "react-datepicker";
//////////////////////////////////range date picker /////////////////////
import { addDays } from "date-fns";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
/////////////////////////////////////////
//import { FR } from "date-fns/locale";
import Fr from "date-fns/locale/fr"; // register it with the name you want
import "react-datepicker/dist/react-datepicker.css";
import * as rdrLocales from "react-date-range/dist/locale";
///////////////////////////////////////////////////////////////////////////////
import { Fab, Action } from "react-tiny-fab";
import Logo from "../../../asset/logo";
import Webphone from "../../webphone/Webphone"; // the locale you want
import { Disclosure, Menu, Transition } from "@headlessui/react";

//registerLocale("Fr", Fr);

//import DatePicker from "react-datepicker";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
function useMounted() {
  const [isMounted, setIsMounted] = useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);
  return isMounted;
}

const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;
function Journal({ t }) {
  const [croix, setcroix] = useState(false);
  function test() {
    setSearchText("");
    getAllcollegues();
    // console.log("heeeeeeeeeey", searchText);

    setcroix(true);
  }
  const isMounted = useMounted();
  const people = [
    {
      id: 1,
      name: "Tous les appels",
      state: "absence",
    },
    {
      id: 2,
      name: "Appels internes",
      state: "absence_interne",
    },
    {
      id: 3,
      name: "Appels externes",
      state: "absence_externe",
    },
  ];
  const [selected, setSelected] = useState(people[0]);
  // const ring = document.getElementById("ringtone");
  // const [collegues, setCollegue] = useState([]);
  //const [value, onChange] = useState(new Date());

  const [loading, setloading] = useState("false");

  const [black1, changeColor1] = useState(
    "dark:text-white dark:hover:text-gray-400  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-2 px-1 border-b-2 font-medium text-sm"
  );
  const [black2, changeColor2] = useState(
    "dark:text-white dark:hover:text-gray-400 mr-1 pr-1 md:mr-2 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );
  const [black3, changeColor3] = useState(
    "dark:text-white dark:hover:text-gray-400  mr-1 pr-1 md:mr-2 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );
  const [black4, changeColor4] = useState(
    "mr-1 pr-1 md:mr-2 md:pr-2 lg:mr-8 lg:pr-4 dark:hover:text-gray-400 border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );

  const [absence, setAbsence] = useState("all");

  const [colleguesPerPage] = useState(100);
  const [offset, setOffset] = useState(1);
  const [collegues, setAllcollegues] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [collguesforpagination, setPageCollegues] = useState([]);

  const [allcontact, setContacts] = useState([]);
  const [allcollegue, setCollegue] = useState([]);
  const [allNames, setAllNames] = useState([]);

  const [calender, setcalender] = useState(false);

  const [startDate2, setStartDate2] = useState(new Date());
  const [startDate3, setStartDate3] = useState(new Date());
  const [collegues2, setAllcollegues2] = useState([]);
  const length = () => {
    return (
      <div className="flex">
        {1 + (offset - 1) * colleguesPerPage} - {offset * colleguesPerPage}{" "}
        {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpagination.length}
        </div>
      </div>
    );
  };
  const length2 = () => {
    return (
      <div className="flex">
        {1 + (offset - 1) * colleguesPerPage} - {collguesforpagination.length}{" "}
        {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpagination.length}
        </div>
      </div>
    );
  };

  let countforpagination =
    1 +
    (offset - 1) * colleguesPerPage +
    " - " +
    offset * colleguesPerPage +
    "  sur  " +
    collguesforpagination.length;

  let countforpagination2 =
    1 +
    (offset - 1) * colleguesPerPage +
    " - " +
    collguesforpagination.length +
    "  sur  " +
    collguesforpagination.length;

  const [state, setState] = useState([
    {
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  let dateformat =
    "Du " +
    state[0].startDate.toLocaleDateString("fr-FR") +
    " au " +
    state[0].endDate.toLocaleDateString("fr-FR");
  function handleSelect(ranges) {
    // {
    //   selection: {
    //     startDate: [native Date Object],
    //     endDate: [native Date Object],
    //   }
    // }
  }

  const onclickfiltredDate = () => {
    setcalender(true);
    filtreDate();
    changeColor4(
      "mr-8  pr-4  dark:hover:text-gray-400 border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor2(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor1(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
  };
  const filtreDate = () => {
    setloading(true);
    var dd = new Date(startDate2).toISOString().split("T")[0];
    var df = new Date(startDate3).toISOString().split("T")[0];
    var lien = window.location.href;
    // console.log(lien);
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=${dd}&date_fin=${df}&filter=all`,
        config
      )
      .then((res) => {
        const data = res.data.log_appel.reverse();
        setPageCollegues(data);
        const slice = data.slice(
          (offset - 1) * colleguesPerPage,
          offset * colleguesPerPage
        );
        //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
        //console.log(slice);

        // For displaying Data
        const postData = getPostData(slice);

        // Using Hooks to set value
        setAllcollegues(postData);
        setPageCount(Math.ceil(data.length / colleguesPerPage));
        setloading(false);
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  const filtreDate2 = () => {
    setloading(true);
    var dd = new Date(state[0].startDate).toISOString().split("T")[0];
    var df = new Date(state[0].endDate).toISOString().split("T")[0];
    var lien = window.location.href;
    const var2 = lien.split("/");
    var var4 = var2[2].split(":");
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=${dd}&date_fin=${df}&filter=all`,
        config
      )
      .then((res) => {
        const data = res.data.log_appel.reverse();
        setPageCollegues(data);
        const slice = data.slice(
          (offset - 1) * colleguesPerPage,
          offset * colleguesPerPage
        );
        //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)

        // For displaying Data
        const postData = getPostData(slice);

        // Using Hooks to set value
        setAllcollegues(postData);
        setPageCount(Math.ceil(data.length / colleguesPerPage));
        setloading(false);
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };

  function handleOrangeClick() {
    //setSelected(selected);
    // Similar to this.setState({ fruit: 'orange' })
    // document.getElementById("notif").classList.remove("bg-opacity-100");

    setAbsence("abs");
    changeColor1(
      "dark:hover:text-gray-400 border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor4(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor2(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    setcalender(false);
    setrecherche(false);
    setOffset(1);
  }
  function handleOrangeClick2() {
    // Similar to this.setState({ fruit: 'orange' })
    setAbsence("emis");
    changeColor2(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 dark:hover:text-gray-400 border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor4(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor1(
      "dark:text-white dark:hover:text-gray-400  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    setcalender(false);
    setrecherche(false);

    setOffset(1);
  }
  function handleOrangeClick3() {
    // Similar to this.setState({ fruit: 'orange' })
    setAbsence("recu");
    changeColor3(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 dark:hover:text-gray-400 pr-4 border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor4(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor2(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor1(
      "dark:text-whitemr-2 dark:hover:text-gray-400  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    setcalender(false);
    setrecherche(false);

    setOffset(1);
  }
  function handleOrangeClick4() {
    document.getElementById("notif").classList.remove("bg-opacity-100");
    // Similar to this.setState({ fruit: 'orange' })
    setAbsence("all");
    changeColor4(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 dark:hover:text-gray-400 border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor2(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor1(
      "dark:text-white dark:hover:text-gray-400 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    setcalender(false);
    setrecherche(false);

    setOffset(1);
  }
  function handleresearchui() {
    // Similar to this.setState({ fruit: 'orange' })
    changeColor4(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 dark:hover:text-gray-400 border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor2(
      "dark:text-white dark:hover:text-gray-400 mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor1(
      "dark:text-white dark:hover:text-gray-400 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );

    setOffset(1);
  }
  /***************************************Collegue Names ****************************************/
  const getcollegueNames = () => {
    var lien = window.location.href;
    const var2 = lien.split("/");
    var var4 = var2[2].split(":");
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ColleguesIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        setCollegue(res.data.collegues);
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };

  /****************************************************Contact Names*************************/
  const getcontactNames = () => {
    var lien = window.location.href;
    const var2 = lien.split("/");
    var var4 = var2[2].split(":");
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        setContacts(res.data.carnet_adresse);
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };

  /****************************Names contact + Collegue Concatination**************************/

  async function getallNames() {
    await Promise.all([getcollegueNames(), getcontactNames()]);

    const NONO = allcontact.concat(allcollegue);
    setAllNames(NONO);

    return NONO;
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const getAllcollegues = async () => {
    setloading(true);
    if (absence === "all") {
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filter=all`,
          config
        )
        .then((res) => {
          setloading(false);

          // console.log("Now Names", allNames);
          const data = res.data.log_appel.reverse();
          setPageCollegues(data);
          //console.log("all");
          setAllcollegues2(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );
          //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)

          // For displaying Data
          const postData = getPostData(slice, allNames);
          // Using Hooks t o set value
          setAllcollegues(postData);

          setPageCount(Math.ceil(data.length / colleguesPerPage));
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }

    if (absence === "abs") {
      setloading(true);
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const result = await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filter=${selected.state}`,
          config
        )
        .then((res) => {
          setloading(false);

          const data = res.data.log_appel.reverse();
          setPageCollegues(data);

          //  console.log(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );
          //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
          // console.log(slice);

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / colleguesPerPage));
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }

    if (absence === "emis") {
      setloading(true);
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const result = await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filter=emis`,
          config
        )
        .then((res) => {
          setloading(false);

          const data = res.data.log_appel.reverse();
          setPageCollegues(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );
          //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
          // console.log(slice);

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / colleguesPerPage));
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
    if (absence === "recu") {
      setloading(true);
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const result = await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/LogAppelIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filter=recu`,
          config
        )
        .then((res) => {
          setloading(false);

          const data = res.data.log_appel.reverse();
          setPageCollegues(data);

          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );
          //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
          // console.log(slice);

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / colleguesPerPage));
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setOffset(selectedPage + 1);
  };

  const getPostData = (data, tabname) => {
    return data.map((post) => (
      <Journalbox
        person={post}
        key={post.id}
        toggle={getAllcollegues}
        genre={selected.state}
      />
    ));
  };

  useEffect(() => {
    if (calender == true) {
      filtreDate();
    } else if (recherche == true) {
      filterData(searchText);
    } else {
      getallNames();
      getAllcollegues();
    }
  }, [absence, offset, calender]);
  useEffect(() => {
    if (isMounted) {
      handleOrangeClick();
      if (absence == "abs") {
        getAllcollegues();
        return () => {
          setAbsence("all");
        };
      }
    }
  }, [selected]);

  const hi = () => setcalender(false);

  const [searchText, setSearchText] = useState("");
  const excludeColumns = [
    "id_appel",
    "dstchannel",
    "accountcode",
    "amaflags",
    " billsec",
    "calldate_answer",
    "calldate_start ",
    "channel",
    "clid",
    "dcontext ",
    "disposition",
    "dstchannel",
    "duration",
    "etat_queue",
    "genre_appel",
    "id",
    "id_enregistrement",
    "lastapp",
    "lastdata",
    "ringingsec",
    "sda",
    "sens_appel",
    "type_appel",
    "uniqueid",
    "userfield",
    "valeur_saisie",
  ];
  const filterData = (value) => {
    handleresearchui();

    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue === "") getAllcollegues();
    else {
      const filteredData = collegues2.filter((item) => {
        return Object.keys(item).some((key) =>
          excludeColumns.includes(key)
            ? false
            : item[key].toString().toLowerCase().includes(lowercasedValue)
        );
      });

      setPageCollegues(filteredData);
      setOffset(1);
      const slice = filteredData.slice(
        (offset - 1) * colleguesPerPage,
        offset * colleguesPerPage
      );

      const postData = getPostData(slice);

      // Using Hooks to set value
      setAllcollegues(postData);
      setPageCount(Math.ceil(filteredData.length / colleguesPerPage));
      //getPostData(filteredData);
    }
  };
  const [recherche, setrecherche] = useState(false);
  const handleChange = (value) => {
    setcalender(false);
    setrecherche(true);
    setSearchText(value);
    filterData(value);
  };

  const [showModal, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  if (loading == false) {
    return (
      <div className="content pb-4 flex flex-col h-screen">
        <div className="py-4">
          <div className="md:flex md:items-center md:justify-between mb-4 mx-4 sticky top-0">
            <div className="flex-1 min-w-1 flex ">
              <h2 className=" dark:text-white text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
                {t("journal.title")}{" "}
                {/* <span className="text-gray-600 text-sm rounded-xl bg-gray-100 ml-2 -mt-16 px-2 py-1">
                  <span>{collguesforpagination.length}</span>
                  <span className="text-gray-500 text-xs ml-1">appels</span>
                </span> */}
              </h2>
            </div>
            <Menu as="div" className="ml-4 relative flex-shrink-0">
              {({ open }) => (
                <>
                  <div>
                    <div className="flex text-sm text-gray-500 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-offset-green-300 focus:ring-white">
                      {/* <Menu.Button
                        className="mr-6"
                        //className="hover:border-green-600 rounded-md inline-flex items-center p-2 border border-transparent shadow-sm text-xs font-medium text-gray-500 bg-grey-100 hover:text-green-600 focus:outline-none "
                        style={{
                          webKitBoxShadow:
                            " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                          boxShadow:
                            " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                        }}
                      > */}{" "}
                      <button onClick={hi}>
                        {/* <span className="inline-block relative">
                            <span class="px-1 py-1 w-full inline-flex items-center justify-center h-8 w-8   bg-grey-100">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                />
                              </svg>
                            </span>
                          </span> */}

                        {/* <input
                            type="text"
                            // placeholder="Chercher un Collegue"
                            className="dark:bg-gray-600 dark:text-gray-300 pl-12 min-w-full mr-20 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-2 pl-2"
                            placeholder=""
                            value={dateformat}
                            //onChange={(e) => handleChange(e.target.value)}
                          /> */}
                        {/* <div className="dark:text-white absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                        </div> */}
                      </button>
                      {/* </Menu.Button> */}
                    </div>
                  </div>
                  <Transition
                    show={open}
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items
                    // static
                    // className="origin-top-right absolute z-10 right-0 mt-2 px-4 space-y-4 w-56 rounded-md shadow-lg py-3 bg-white  text-sm text-gray-700 dark:text-gray-300 divide-y divide-gray-100 dark:divide-gray-700 ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800"
                    >
                      <DateRangePicker
                        onChange={(item) => {
                          setState([item.selection]);
                          filtreDate2();
                        }}
                        showSelectionPreview={true}
                        //onChange={handleSelect(state)}
                        //moveRangeOnFirstSelection={false}
                        months={2}
                        ranges={state}
                        direction="horizontal"
                        //     preventSnapRefocus={true}
                        calendarFocus="backwards"
                        //onChange={handleSelect}
                        className="absolute -ml-96 mt-8"
                        locale={rdrLocales.fr}
                      />
                    </Menu.Items>
                  </Transition>
                </>
              )}
            </Menu>
            <div className="mt-1  relative rounded-md shadow-sm">
              <input
                type="text"
                className=" dark:bg-gray-600 dark:text-gray-200 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-12 pl-12"
                placeholder={t("findcall")}
                value={searchText}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                  webKitBoxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  boxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                }}
              />
              <div className="dark:text-white absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none ">
                <svg
                  className="h-5 w-5 text-gray-400 "
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              {searchText != "" ? (
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 pl-3 flex items-center dark:text-gray-100 transition-al hover:bg-gray-100"
                  onClick={() => {
                    test();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              ) : (
                <div></div>
              )}
            </div>
            {/* ////////////////////////:calender////////////// */}
          </div>
        </div>

        <div className="dark:border-gray-800 border-b border-gray-200 dark:text-white transition-al">
          {collguesforpagination.length !== 0 ? (
            <div className="flex">
              <div className="flex" style={{ marginLeft: "auto", order: "2" }}>
                <span
                  className="text-gray-500 dark:text-white"
                  //  style={{ marginLeft: "auto", order: "2" }}
                >
                  {offset == pageCount ? length2() : length()}
                </span>

                <ReactPaginate
                  previousLabel={"<"}
                  previousClassName={
                    "p-0.5 md:p-1.5 lg:p-1.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center  border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                  }
                  nextLabel={">"}
                  nextClassName={
                    "pl-1.5 lg:pl-2.5 md:pl-2.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center p-1.5 border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                  }
                  breakLabel={"countforpagination"}
                  breakClassName={"hidden"}
                  pageClassName={
                    "hidden relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                  }
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                  containerClassName={
                    "relative z-0 inline-flex rounded-md  -space-x-px"
                  }
                  activeClassName=""
                  forcePage={offset - 2}
                />
              </div>
            </div>
          ) : (
            <div></div>
          )}
          <nav className="flex-1 min-w-4 " aria-label="Tabs">
            <a href="#" className={black4} onClick={() => handleOrangeClick4()}>
              {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg> */}

              <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                {t("journal.allcall")}{" "}
              </span>
              <span className="lg:hidden md:hidden">Tous</span>
            </a>

            <a
              href="#"
              className={black3}
              aria-current="page"
              onClick={() => handleOrangeClick3()}
            >
              <span>{t("incoming.calls")}</span>
            </a>

            <a href="#" className={black2} onClick={() => handleOrangeClick2()}>
              <span>{t("outgoing.calls")}</span>
            </a>
            <a href="#" className={black1}>
              {/* <span>{t("missedcalls")}</span> */}
              <Listbox
                value={selected}
                onChange={setSelected}
                onClick={handleOrangeClick}
              >
                {({ open }) => (
                  <>
                    <div className="flex">
                      <Listbox.Button
                        className="flex"
                        //   onChange={changeLanguage2(selected.sortcut)}
                      >
                        <span className="text-sm font-medium">
                          {t("missedcalls")}
                        </span>

                        <span className=" pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4 ml-1 mt-1"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </span>
                      </Listbox.Button>

                      <Transition
                        show={open}
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <Listbox.Options className=" absolute  mt-8 w-38 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {people.map((person) => (
                            <Listbox.Option
                              key={person.id}
                              className={({ active }) =>
                                classNames(
                                  active
                                    ? "text-white bg-green-500"
                                    : "text-gray-900",
                                  "cursor-default select-none relative py-2 pl-3 pr-9"
                                )
                              }
                              value={person}
                            >
                              {({ selected, active }) => (
                                <>
                                  <div className="flex items-center">
                                    <span
                                      className={classNames(
                                        selected
                                          ? "font-semibold"
                                          : "font-normal",
                                        "ml-3 block truncate"
                                      )}
                                    >
                                      {person.name}
                                    </span>
                                  </div>

                                  {selected ? (
                                    <span
                                      className={classNames(
                                        active
                                          ? "text-white"
                                          : "text-indigo-600",
                                        "absolute inset-y-0 right-0 flex items-center pr-4"
                                      )}
                                    >
                                      <CheckIcon
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                    </span>
                                  ) : null}
                                </>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
              </Listbox>
            </a>
          </nav>
        </div>

        {collguesforpagination.length !== 0 ? (
          <div className=" dark:bg-gray-900 flex flex-col overflow-y-auto  ">
            <div className=" dark:bg-gray-900">
              <div className=" dark:bg-gray-900 align-middle inline-block min-w-full shadow overflow-hidden border-b border-gray-200">
                <table className="min-w-full dark:bg-gray-900 dark:text-white transition-al">
                  <thead>
                    <tr className="">
                      <th className=" dark:bg-gray-600 dark:text-white w-12 px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        &nbsp;
                      </th>
                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        {t("Nom.contact.table")}
                      </th>
                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        {t("calldate")}
                      </th>
                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        {t("callduree")}
                      </th>

                      <th className="dark:bg-gray-600 dark:text-white  px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">{collegues}</tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <div className="justify-center mt-64 pr-96">
            <h2 className="pl-44 dark:text-white text-lg font-medium leading-7  sm:text-3xl sm:truncate text-gray-400">
              {t("nocallhistory")}{" "}
            </h2>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className="content pb-4">
        <div className="py-4">
          <div className="md:flex md:items-center md:justify-between mb-4 mx-4 sticky top-0">
            <div className="flex-1 min-w-1 flex ">
              <h2 className="dark:text-white  text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
                {t("journal.title")}{" "}
              </h2>
            </div>
            <Menu as="div" className="ml-4 relative flex-shrink-0">
              {({ open }) => (
                <>
                  <div>
                    <div className="flex text-sm text-gray-500 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-offset-green-300 focus:ring-white">
                      <button onClick={hi}>
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none "></div>
                      </button>
                    </div>
                  </div>
                  <Transition
                    show={open}
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items>
                      <DateRangePicker
                        onChange={(item) => {
                          setState([item.selection]);
                          // console.log(state);
                          filtreDate2();
                        }}
                        showSelectionPreview={true}
                        //onChange={handleSelect(state)}
                        //moveRangeOnFirstSelection={false}
                        months={2}
                        ranges={state}
                        direction="horizontal"
                        //     preventSnapRefocus={true}
                        calendarFocus="backwards"
                        //onChange={handleSelect}
                        className="absolute -ml-96 mt-8"
                        locale={rdrLocales.fr}
                      />
                    </Menu.Items>
                  </Transition>
                </>
              )}
            </Menu>
            <div className="mt-1  relative rounded-md shadow-sm">
              <input
                type="text"
                className="dark:bg-gray-600 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-12 pl-12"
                placeholder={t("findcall")}
                value={searchText}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                  webKitBoxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  boxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                }}
              />
              <div className="dark:text-white absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none ">
                <svg
                  className="h-5 w-5 text-gray-400 dark:text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div className="">
          <div className="flex flex-wrap justify-center  mt-64">
            <ScaleLoader
              color="#109669"
              loading={loading}
              size={50}
              width={4}
              height={68}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation("common")(Journal);
